<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" :offset="[9, 0]" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="plain" color="textPrimary">
          <span class="profile-dropdown__anchor min-w-max">
            <slot />
            <VaAvatar color="primary" class="font-[Orbitron] font-bold hover:opacity-70">
              {{ userStore.profile?.name[0] + '' + userStore.profile?.surname[0] }}
            </VaAvatar>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent
        class="profile-dropdown__content md:w-60 px-0 py-4 w-full"
        :style="{ '--hover-color': hoverColor }"
      >
        <VaList>
          <header class="uppercase text-[var(--va-secondary)] opacity-70 font-bold text-xs px-4">
            {{ $t('profile.account') }}
          </header>
          <VaListItem :to="{ name: 'preferences' }" class="menu-item px-4 text-base cursor-pointer h-8">
            <VaIcon name="mso-account_circle" class="pr-1" color="secondary" />
            {{ t('menu.preferences') }}
          </VaListItem>
          <VaListSeparator class="mx-3 my-2" />
        </VaList>
        <VaList>
          <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" @click="logout()">
            <VaIcon name="mso-logout" class="pr-1" color="secondary" />
            {{ t('menu.logout') }}
          </VaListItem>
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'
import { useUserStore } from '../../../../stores/user-store'
import { useRouter } from 'vue-router'

const userStore = useUserStore()
const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const { t } = useI18n()
const { push } = useRouter()

const isShown = ref(false)

const logout = () => {
  userStore.logout()

  push({ name: 'intro' })
}
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
</style>
